export default "__VITE_ASSET__CVm$Wg1h__"